module.exports = __webpack_public_path__ + "b2d7f45e29226d65dc7cb346b758a7fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/MainMenu/MenuComboPackage.png
// module id = 406
// module chunks = 0